module.exports = __webpack_public_path__ + "img/lareina-pro.e82a5cb9.jpg";